import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { saveSearchedItems } from '../../../store/actions';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import './AreasSearchWrapper.css';

export class AreasSearchWrapperComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchName: '',
      searchMinPop: 0,
      searchMaxPop: Infinity,
      areas: props.areas,
    };

    this.onSearch = this.onSearch.bind(this);
    this.applySearch = this.applySearch.bind(this);
    this.getSearchedAreas = this.getSearchedAreas.bind(this);
  }

  componentDidMount() {
    if (this.props.areas.length) {
      this.updateState(this.props.areas);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.areas !== prevProps.areas) {
      this.updateState(this.props.areas);
    }
  }

  onSearch() {
    const searchName = this.searchNameInput.value.toUpperCase();
    const searchMinPop = parseInt(this.searchMinPopInput.value, 10);
    const searchMaxPop = parseInt(this.searchMaxPopInput.value, 10);

    this.setState({
      searchName,
      searchMinPop: isNaN(searchMinPop) ? 0 : searchMinPop,
      searchMaxPop: isNaN(searchMaxPop) ? Infinity : searchMaxPop,
    }, () => {
      this.getSearchedAreas();
    });
  }

  getSearchedAreas() {
    const result = this.props.areas.filter(this.applySearch);
    this.updateState(result);
  }

  applySearch({ name, population }) {
    return this.findName(name) && this.findPopulation(population);
  }

  updateState(areas) {
    this.setState({
      areas,
    }, () => {
      this.props.saveSearchedList(areas);
    });
  }

  findName(name) {
    const { searchName } = this.state;
    return (searchName === '') ? true : (name.toUpperCase().indexOf(searchName) > -1);
  }

  findPopulation(population) {
    const { searchMinPop, searchMaxPop } = this.state;
    return (searchMinPop === 0 && searchMaxPop === Infinity) ? true :
      (population >= searchMinPop && population <= searchMaxPop);
  }

  render() {
    const { render } = this.props;
    const { areas, searchMinPop, searchMaxPop } = this.state;

    return (
      <div>
        <div className="areas-search">
          <p>Search By Name</p>
          <input type="text" ref={input => { this.searchNameInput = input; }} />

          <div className="areas-search-populations">
            <p>Minimum Population</p>
            <input type="text" ref={input => { this.searchMinPopInput = input; }} />
          </div>

          <div className="areas-search-populations">
            <p>Maximum Population</p>
            <input type="text" ref={input => { this.searchMaxPopInput = input; }} />
          </div>

          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <button className="btn" onClick={this.onSearch}>Search</button>
          </ViewerPrimaryColorUserStyle>
        </div>

        <ul className="list-wrapper">
          {render({
            searchMinPop,
            searchMaxPop,
            areas,
          })}
        </ul>
      </div>
    );
  }
}

AreasSearchWrapperComponent.propTypes = {
  areas: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      population: PropTypes.number,
    }),
  ).isRequired,
  render: PropTypes.func.isRequired,
  saveSearchedList: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    saveSearchedList: items => {
      const result = items.map(item => item.id);
      dispatch(saveSearchedItems(result));
    },
  };
}

export default connect(null, mapDispatchToProps)(AreasSearchWrapperComponent);



// WEBPACK FOOTER //
// ./src/components/List/Areas/AreasSearchWrapper.js